module.exports = __webpack_public_path__ + "img/imaginary-ones.0ee439e0.png";